<dashboard-dialog-frame class="person-dialog" [header]="headerName()" [actions]="actions()" (actionClick)="displayEditorView()" [dialogRef]="dialogRef">

	@if(dialogContext.data?.personId; as personId){
	@if(toEdit()){
	<person-editor-view-part [personId]="personId"></person-editor-view-part>
	} @else {
	<person-explorer-view-part [personId]="personId" [dialogBodyHeight]="dialogContext.dimensions().bodyHeight"></person-explorer-view-part>
	}
	}

</dashboard-dialog-frame>